module.exports = __webpack_public_path__ + "img/settings-abe6a1ab3b15e5d56212e34fa53544ae.svg";